export const SSO_WIDGET_URL = process.env.SSO_WIDGET_URL || 'https://sso-widget.stgairasia.com/bundle.en-GB.js.gz';
export const SSO_WIDGET_STYLE_URL = process.env.SSO_WIDGET_STYLE_URL || 'https://sso-widget.stgairasia.com/style.css.gz';